import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import firebase from 'firebase/app'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Notifications from 'vue-notification'
import smoothScroll from 'vue-smoothscroll'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import VueHead from 'vue-head'
import VueYoutube from 'vue-youtube'
import VueLazyload from 'vue-lazyload'

require('firebase/firestore')
require('firebase/auth')
require('firebase/storage')
require('firebase/functions')

Vue.config.productionTip = false

var firebaseConfig = {
  apiKey: "AIzaSyDmX6vXVsDE_z-PA96n1PxjiZhK7S7gk7k",
  authDomain: "hotfood-dev-ce143.firebaseapp.com",
  databaseURL: "https://hotfood-dev-ce143.firebaseio.com",
  projectId: "hotfood-dev-ce143",
  storageBucket: "hotfood-dev-ce143.appspot.com",
  messagingSenderId: "927825230364",
  appId: "1:927825230364:web:a5b3116cc4c7d655"
}

firebase.initializeApp(firebaseConfig)
export const db = firebase.firestore()
export const auth = firebase.auth()
export const storageRef = firebase.storage().ref()
export const functions = firebase.functions()

export const providerTwitter = new firebase.auth.TwitterAuthProvider()
export const providerFacebook = new firebase.auth.FacebookAuthProvider()
export const providerGoogle = new firebase.auth.GoogleAuthProvider()

// 認証状態のチェック 
auth.onAuthStateChanged(user => {
  if (user) {
    if (user.uid === store.state.user.uid) {
      // ログイン済
    } else {
      store.commit('logout')
    }
  } else {
    store.commit('logout')
  }
})

// Vuexの初期化
store.commit('initFood')
store.commit('initShops')
store.commit('initPost')
store.commit('initMagazin')
store.commit('initNews')
store.commit('deleteTempFoodData')
store.commit('initRank')
store.dispatch('getCategoryAndTag')
store.dispatch('getTabetai')
store.dispatch('getUserInfo')

Vue.use(Vuetify, {
  theme: {
    primary: '#F44336',
    error: '#FF5722'
  }
})
Vue.use(Notifications)
Vue.use(smoothScroll)
Vue.use(Croppa)
Vue.use(VueHead)
Vue.use(VueYoutube)
Vue.use(VueLazyload, {
  preLoad: 1.5,
  // error: 'https://dummyimage.com/130x120/ccc/999.png&text=Not+Found',
  loading: require('@/assets/img/icon_loader.gif'),
  // attempt: 3
  lazyComponent: true
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// algolia
const algoliasearch = require('algoliasearch')
const client = algoliasearch('3B8CJ24EXO', '5c1389523076e1c792ecffa7a99da65d')
export const algolia_food = client.initIndex('karaimonotabetai')
export const algolia_shops = client.initIndex('karaiine_shops')

